export default (theme) => ({
  container: {
    paddingTop: theme.spacing(2),
  },
  dayLabel: {
    textTransform: 'capitalize',
  },
  timeSection: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  timeInputsBox: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  distributionSection: {
    marginBottom: theme.spacing(2),
  },
  distributionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  distributionItem: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  distributionInputs: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  percentageField: {
    width: 180,
  },
  totalBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
  },
});
